import { useAccount } from 'wagmi'
// import { useAuthState } from 'src/contexts/authContext'
import { axiosInstance } from 'src/util/axios.js'
import { evmData, evmDataType } from 'src/util/networksData'
import { evmIds, evmIdsType } from 'src/util/chainIds'

export interface ITokenDetails {
  name: string
  supply: string
  symbol: string
  decimals: string
}

const useValidateToken = () => {
  const { address } = useAccount()

  const validateToken = async ({
    tokenAddress,
    chain,
    network,
  }: {
    tokenAddress: string
    chain: string
    network: string
  }) => {
    if (!tokenAddress) {
      return {
        isValid: false,
        data: null,
        error: '',
      }
    }

    if (tokenAddress.length !== 42) {
      return {
        isValid: false,
        data: null,
        error: 'Invalid token contract address length.',
      }
    }
    try {
      const chainParams = {
        ethereum: 'eth',
        bnb: 'bsc',
        polygon: 'matic',
      }
      const networkData = evmData[chain as keyof evmDataType][network]
      const chainId = evmIds[chain as keyof evmIdsType][network]

      await axiosInstance.post(
        `/blockchain-helpers/${
          chainParams[chain as 'ethereum' | 'bnb' | 'polygon']
        }/smartContract/getAbi`,
        {
          address: address,
          networkProvider: networkData.rpcUrls[0],
          smartContractAddress: tokenAddress,
          environment: network,
          ...(chain === 'ethereum' ? { chainId } : {}),
        },
      )

      const tokenResponse = await axiosInstance.post('/blockchain-helpers/getTokenDetails', {
        scAddress: tokenAddress,
        chain: chain.toLowerCase(),
        environment: network,
        networkProvider: networkData.rpcUrls[0],
        ...(chain === 'ethereum' ? { chainId } : {}),
      })

      return {
        isValid: true,
        data: tokenResponse.data?.data,
        error: '',
      }
    } catch (error) {
      return {
        isValid: false,
        data: null,
        error: 'You have to type in a verified token contract address.',
      }
    }
  }

  return {
    validateToken,
  }
}

export default useValidateToken
